import { render } from "./Preloader.vue?vue&type=template&id=0eefbf48&scoped=true"
const script = {}

import "./Preloader.vue?vue&type=style&index=0&id=0eefbf48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eefbf48"]])

export default __exports__